import React from 'react'
import styles from '../styles.module.scss'


const FilesBlock = () => {
  return (
    <div className={styles.filesBlock}>
      <p>Файлы:</p>
    </div>
  )
}

export default FilesBlock